// extracted by mini-css-extract-plugin
export default {"NoData_bgImageContainer":"NoData_NoData_bgImageContainer__zOtFH","Nodata":"NoData_Nodata__DT+q-","ImageLabel":"NoData_ImageLabel__JNsc0"};